import useApiMutation from '../useApiMutation';

const useGenerateContent = () => {
  const mutation = useApiMutation({
    getRequestUrl: ({ showId, jobId }) => `/shows/${showId}/transcript/${jobId}/generate`,
    method: 'GET',
  });

  return {
    generateContent: mutation.mutate,
    isGenerateContentLoading: mutation.isLoading,
    generatedContent: mutation.data,
    generateContentError: mutation.error,
  };
};

export default useGenerateContent;
